import type React from 'react';

import { PageSkipButton } from '#src/app/pages/psf/share/shared/components';

import { usePageFooter } from './hooks/usePageFooter';

export const PageFooter: React.FC = () => {
	const {
		data: { skipLabel, skipUrl },
		actions: { handleSkipClick },
	} = usePageFooter();

	return (
		<div className="px-4 py-7 text-center md:mt-5">
			<PageSkipButton skipUrl={skipUrl} skipLabel={skipLabel} onSkipClick={handleSkipClick} />
		</div>
	);
};
